import React, { useEffect } from 'react'
import InviteInterpreterList from './InviteInterpreterTable'
import { useParams, useNavigate } from 'react-router-dom'
import { fetchAppointmentView } from 'slices/appointmentSlice'
import { useDispatch } from 'react-redux'
import toast from 'react-hot-toast'

const InviteInterpreter = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()
    const [item, setItem] = React.useState({});
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        const callBack = (success, message, data) => {
            setLoading(false)
            if (success) {
                if (data?.status !== 'available') {
                    toast.error('This appointment invite is no longer available.')
                    navigate('/')
                    return
                }
                setItem(data)
            }
            else {
                console.log(message)
            }
        }

        dispatch(fetchAppointmentView(id, callBack))
    }, [id])

    return (

        <InviteInterpreterList itemId={id} appointmentData={item}/>
    )
}

export default InviteInterpreter